module.exports = __webpack_public_path__ + "static/media/logoutImg.96f9ee09.svg";